import React from 'react'
import { Redirect } from 'react-router-dom'
import NewHeader from 'components/layout/Header/index'

const PrivateRoute = ({ Component, isAuthenticated, child, isHeader, isFooter }) => {
  return isAuthenticated
    ? (
      <>
        {isHeader ? <NewHeader /> : <></>}
        <Component child={child} />
      </>
      )
    : (
      <Redirect to={{ pathname: '/' }} />
      )
}

export default PrivateRoute
